import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import NcButton from '@nextcloud/vue/components/NcButton';

import Searchbar from '@components/header/Searchbar.vue';

import { windowDims } from '@services/viewport';
import { t } from '@services/l10n';

import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchbarMenuItem',
  setup(__props) {

function search() {
  _m.modals.search();
}

return (_ctx: any,_cache: any) => {
  return (_unref(windowDims).isMobile)
    ? (_openBlock(), _createBlock(_unref(NcButton), {
        key: 0,
        class: "memories-menu-item search-menu",
        variant: "tertiary-no-background",
        title: _unref(t)('memories', 'Search'),
        "aria-label": _unref(t)('memories', 'Search'),
        onClick: search
      }, {
        icon: _withCtx(() => [
          _createVNode(MagnifyIcon, { size: 20 })
        ]),
        _: 1
      }, 8, ["title", "aria-label"]))
    : (_openBlock(), _createBlock(Searchbar, { key: 1 }))
}
}

})